export { default } from './js/CBApricotD8';

